<form [formGroup]="form" class="schedule-datepicker">
  <div class="row g-0">
    <div [class]="showSchedules ? 'col-12 col-lg-7 mb-3 mb-lg-0' : 'col-12'">
      <div class="calendar-card">
        <ngb-datepicker
          *ngIf="datepickerVisible"
          #dp
          navigation="arrows"
          outsideDays="hidden"
          class="w-100"
          [ngModel]="selectedDateModel"
          [ngModelOptions]="{ standalone: true }"
          [minDate]="datepicker?.minDate"
          [maxDate]="datepicker?.maxDate"
          (dateSelect)="selectDate($event)"
          [markDisabled]="isDisabled">
        </ngb-datepicker>
      </div>
      <p *ngIf="!showSchedules && selectedDateLabel" class="calendar-date-label">
        {{ selectedDateLabel }}
      </p>
    </div>
    <div
      *ngIf="showSchedules"
      class="col-12 col-lg-5 schedule-datepicker__schedules">
      <h5 class="color-primary mb-3" *ngIf="selectedDateLabel">
        {{ selectedDateLabel }}
      </h5>
      <div *ngIf="schedules as schedules$">
        <ng-container *ngIf="schedules$ | async as list">
          <div *ngIf="list.length; else noSchedules">
            <div class="row" *ngFor="let item of list">
              <div class="form-check d-flex align-items-center w-100">
                <label class="schedule-datepicker__option d-flex align-items-center w-100">
                  <input
                    type="radio"
                    class="form-check-input"
                    formControlName="schedule"
                    [value]="item | json"
                    [class.is-invalid]="form.get('schedule')?.touched && form.get('schedule')?.invalid">
                  <span class="form-check-label" aria-hidden="true"></span>
                  <div class="px-3 py-2 flex-fill">
                    <div class="text-start mb-1">
                      <strong>Sección: {{ item.section }}</strong>
                    </div>
                    <div class="text-start text-secondary">
                      <strong class="me-2">Horario:</strong>
                      {{ item.schedule_range }} hrs
                    </div>
                    <p class="text-center text-white bg-secondary mt-1 p-1 mx-1">
                      {{ item.price | currency:'$ ':'symbol':'.0':'es' }}
                    </p>
                  </div>
                </label>
              </div>
            </div>
          </div>
          <ng-template #noSchedules>
            <p class="mb-1">No hay disponibilidad de despacho para esta fecha.</p>
            <p class="mb-0">Por favor, seleccione otra fecha disponible.</p>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>
</form>
